import { Colors } from '../consts/Colors.js';
import AbstractScene from './AbstractScene.js';
import ButtonRounded from '../prefabs/ButtonRounded.js';
import { Sizes } from '../consts/Sizes.js';
import menuData from '../data/Menu.js';
import { Fonts } from '../consts/Fonts.js';

export default class Menu extends AbstractScene {
    constructor() {
        super({ key: 'Menu' });
    }

    init(data) {
        this._init(data);
    }

    preload() {
        this._preload();
        // Index of the active module
        this.cadresModule = []; // Array to hold the module frames
    }

    update() {
        super.update();
    }

    create() {
        this.cameras.main.setBackgroundColor(Colors.Elmt.White);

        // Afficher l’image
        this.add.image(0, 0, 'background').setOrigin(0);

        // ajouter fleches animées
        this.addAnimatedArrows();

        //Titre menu
        this.add
            .text(this.width / 2, 150, menuData[0].titre, {
                fontFamily: Fonts.Text.h1,
                fontSize: Sizes.Text.h2,
                fill: Colors.Text.White,
                fontWeight: 'bold',
                align: 'center',
                wordWrap: { width: this.width - 40 },
            })
            .setOrigin(0.5, 0.5);

        // Cadre du module
        const moduleCount = 3;
        const cadreWidth = 385;
        const spacing = 150;
        const totalWidth = moduleCount * cadreWidth + (moduleCount - 1) * spacing;
        const startX = (this.width - totalWidth) / 2 + cadreWidth / 2;
        const cadreY = 333 + 514 / 2;
        const robotY = 271;
        const titreY = 600;
        const descY = 667;
        const btnY = 750;

        const robotImages = ['robotVideo', 'robotInfo', 'robotQuiz'];
        const liensBouttons = ['Video', 'Infographie', 'Quiz'];

        this.uiElements = []; // Array to store all UI elements for animation

        for (let i = 0; i < moduleCount; i++) {
            const cadreX = startX + i * (cadreWidth + spacing);

            // Cadre du module
            this.cadreModule = this.add
                .image(
                    cadreX,
                    cadreY,
                    i <= this.game.data.activeIndex ? 'cadreModuleSelected' : 'cadreModule'
                )
                .setOrigin(0.5)
                .setAlpha(1)
                .setScale(1);

            if (i <= this.game.data.activeIndex) {
                this.cadreModule.setInteractive({ cursor: 'pointer' });
                this.cadresModule.push(this.cadreModule);
            }

            this.uiElements.push(this.cadreModule);

            // Robot image
            const robotImg = this.add
                .image(cadreX - cadreWidth / 2, robotY, robotImages[i])
                .setOrigin(0)
                .setScale(1);

            this.uiElements.push(robotImg);

            // Titre du module
            const titreText = this.add
                .text(cadreX, titreY, menuData[0][`titreModule${i + 1}`], {
                    fontFamily: Fonts.Text.h2,
                    fontSize: Sizes.Text.h3,
                    fill: Colors.Text.White,
                    fontWeight: 'bold',
                })
                .setOrigin(0.5, 0.5);

            this.uiElements.push(titreText);

            // Description du module
            const descText = this.add
                .text(cadreX, descY, menuData[0][`descriptionModule${i + 1}`], {
                    fontFamily: Fonts.Text.sub,
                    fontSize: Sizes.Text.h5,
                    fill: Colors.Text.Yellow,
                    align: 'center',
                    wordWrap: { width: cadreWidth - 40 },
                })
                .setOrigin(0.5, 0.5);

            this.uiElements.push(descText);

            // Bouton pour le module
            this[`btnModule${i + 1}`] = this.add
                .image(
                    cadreX,
                    btnY,
                    i < this.game.data.validatedIndex
                        ? 'valideBtn'
                        : i <= this.game.data.activeIndex
                        ? 'suivantBtn'
                        : 'lock'
                )
                .setScale(i <= this.game.data.activeIndex ? 1 : 0.2);

            this.uiElements.push(this[`btnModule${i + 1}`]);
        }

        // Animate all UI elements on first apparition
        this.uiElements.forEach((el, idx) => {
            el.setAlpha(0);
            el.setY(el.y + 50); // Start below the final position
            this.tweens.add({
                targets: el,
                alpha: 1,
                y: el.y - 50,
                delay: idx * 100,
                duration: 400,
                ease: 'Power2',
            });
        });

        // Animate only the elements of the active module
        const activeIdx = this.game.data.activeIndex;
        const elementsPerModule = 5; // cadre, robot, titre, desc, btn
        // Animate only the cadre of the active module
        const cadreIdx = activeIdx * elementsPerModule;
        const cadreEl = this.uiElements[cadreIdx];

        // Interaction pour les cadres de module
        this.cadresModule.forEach((cadre, index) => {
            if (index <= this.game.data.validatedIndex) {
                cadre.on('pointerover', () => {
                    this[`btnModule${index + 1}`].setAlpha(0.7);
                    cadre.setTexture('cadreModuleSelectedHover');
                    if (index < this.game.data.validatedIndex) {
                        this[`btnModule${index + 1}`].setTexture('suivantBtn');
                    }
                    cadre.setAlpha(0.8);
                });
                cadre.on('pointerout', () => {
                    this[`btnModule${index + 1}`].setAlpha(1);
                    if (index < this.game.data.validatedIndex) {
                        this[`btnModule${index + 1}`].setTexture('valideBtn');
                    }
                    cadre.setTexture('cadreModuleSelected');
                    cadre.setAlpha(1);
                });

                cadre.on('pointerdown', () => {
                    this.scene.restart();
                    this.scene.start(liensBouttons[index]);
                });
            }
        });

        // cadre avec texte menu
        const cadreTexteY = 950;
        const cadreTexteMenu = this.add
            .image(this.width / 2, cadreTexteY, 'cadreTexteMenu')
            .setOrigin(0.5)
            .setAlpha(0.8)
            .setScale(1);

        // Place text in the middle of the cadre
        const textDescription = this.add
            .text(cadreTexteMenu.x, cadreTexteMenu.y, menuData[0].descriptionText, {
                fontFamily: Fonts.Text.p,
                fontSize: Sizes.Text.p,
                fill: Colors.Text.White,
                align: 'center',
                wordWrap: { width: cadreTexteMenu.displayWidth - 40 },
            })
            .setOrigin(0.5, 0.5);

        // Bouton "Download the memo"
        this.btnDownload = this.add.existing(
            new ButtonRounded(
                this,
                this.width / 2,
                this.height - 100,
                420,
                76,
                'DOWNLOAD THE MEMO',
                Colors.Text.Blue,
                Colors.Elmt.Yellow,
                true,
                Colors.Elmt.Yellow,
                true,
                false,
                'download',
                ''
            )
        );

        // If downloadMemo is false, hide the cadreTexteMenu
        if (this.game.data.downloadMemo === true) {
            cadreTexteMenu.setVisible(false);
            textDescription.setVisible(false);
            this.btnDownload.setVisible(true);
        } else {
            this.btnDownload.setVisible(false);
            cadreTexteMenu.setVisible(true);
            textDescription.setVisible(true);
        }

        if (cadreEl) {
            this.tweens.add({
                targets: cadreEl,
                scale: 1.1,
                duration: 200,
                yoyo: true,
                repeat: 1,
                delay: this.uiElements.length * 100,
                onComplete: () => {
                    cadreEl.setScale(1);
                },
            });
        }

        // Logo L'Oréal
        this.add
            .image(this.width - 100, this.height - 50, 'logoLoreal')
            .setOrigin(0.5, 0.5)
            .setScale(0.5, 0.5);
    }
}
